import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {User} from '../../../../../models/User';

declare var jQuery;

@Component({
    selector: 'domain-overview-risk',
    templateUrl: './domain-overview-risk.html',
    styleUrls: ['./domain-overview-risk.scss']
})

export class DomainOverviewRisk implements OnInit {
    @Input() domain;
    @Input() region;
    @Input() device;
    @Input() data;
    @Input() month;
    @Input() isFollowing;
    @Output() anchorClick = new EventEmitter<string>();

    loading: boolean;
    deviceMapping = {};
    deviceTypes = [
        { name: 'desktop', tooltip: 'Blended advertiser risk assessment for the Domain on Desktops by global business region' },
        { name: 'mobile', tooltip: 'Blended advertiser risk assessment for the Domain on Mobile Phones by global business region' }
     ];
    tooltipTemplate = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';

    tooltip:any = {
        'High Fraud': 'Significantly Elevated IVT Percentage',
        'Non-Corporate Email': 'Publisher Maintains Non-corporate Email Address',
        'Moderate Fraud': 'Moderately Elevated IVT Percentage',
        'No Privacy Policy': 'Publisher Does Not Publish a Privacy Policy',
        'Private Registration Domain': 'The Publisher Hides their Corporate Details in the Domain Registry',
        'Mail Server Domain Different Than Publisher Domain': 'The Publisher\'s Email Address Doesn\'t Match Their Domain',
        'Adult Content': 'Adult Content Has Been Detected in the App',
        'No Terms Of Service': 'The Publisher Does Not Publish Terms and Conditions',
        'Publisher Domain Not Found': 'The Publisher Domain is Invalid',
        'Gambling Content': 'Gambling Content Has Been Detected in the App',
        'No Ads': 'Programmatic Ads Not Detected Leads to High Spoofing Risk',
        'Violence Content': 'Violent Content Has Been Detected in the App',
        'Very Brand Unsafe Description': 'App Description Uses Brand Unsafe Keywords',
        'Alcohol Content': 'Alchol Based Content Has Been Detected in the App',
        'Moderately Suspicious Traffic Characteristics': 'Ad Traffic Shows Some Suspicious Characteristics',
        'Profanity Content': 'Profanity and Offensive Language Has Been Detected in the App',
        'Brand Unsafe Description': 'App Description Uses Some Brand Unsafe Language',
        'High Click Fraud': 'App Has a High Frequency of Invalid Clicks',
    };

    get isFreemium (): boolean {
      return this.userService.isFreemium();
    }

    constructor(private userService: User) {
    }

    ngOnInit() {
        this.loading = true;

        if (!this.isFreemium) {
            for (const deviceType of this.deviceTypes) {
                this.deviceMapping[deviceType.name] = this.data.overview.reputation.filter(rep => rep.deviceType === deviceType.name);
            }
        }

        this.loading = false;
    }

    goToSection(anchor: string) {
        this.anchorClick.emit(anchor);
    }
}
